import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss']
})
export class DeleteModalComponent implements OnInit {

  message: string = 'Are you sure you want to remove this bookmark ?';
  constructor(
    public modal: NgbActiveModal,
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  closeModal() {
    this.modal.dismiss('no');
  }

  deleteModal() {
    this.modal.close('yes');
  }
}